// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e9e7ec89","730":"417db6c8"}[chunkId] + ".chunk.js";
};